import { useContext } from 'react';
import { InboundContext } from '../../../context/InboundContext';
import PoweredbySaral from '../../../assets/images/powered-by-saral.svg';
import styles from './DescriptionContainer.module.css';
import BrandDescription from '../BrandDescription/BrandDescription';

export default function DescriptionContainer() {
  const { inboundData } = useContext(InboundContext);

  return (
    <div className={styles.descriptionContainer} >
      <div>
        {inboundData?.descriptionPage?.info &&
          inboundData?.descriptionPage?.info?.map((item: { headline: string; subText: string }, index: number) => (
            <BrandDescription
              key={index}
              title={item.headline}
              description={item.subText}
              ctaColor={inboundData.landingPage.colors.ctaBtn}
              colors={inboundData.descriptionPage.colors}
              fontStyle={inboundData.landingPage.fontStyle}
            />
          ))}
      </div>
      <a href="https://getsaral.com" target="_blank" rel="noreferrer">
        <img src={PoweredbySaral} alt="powered by Saral" className={styles.poweredBySaral} />
      </a>
    </div>
  );
}
